import { Button, Text } from "@towersystems/roam-common-native";
import { PermissionResponse, PermissionStatus } from "expo-camera";
import { useEffect, useState } from "react";
import { View } from "react-native";
import { Spacings } from "react-native-ui-lib";
import { PermissionsManager } from "../../../../utilities/permissions";

export type PermissionConfigScreenProps = {
  permissionToken: string;
  cantAskMessage: string;
  deniedMessage: string;
  unsetMessage: string;
  onGrant?: () => void;
  onDeny?: () => void;
};

export function PermissionConfigScreen({
  permissionToken,
  onGrant,
  onDeny,
  cantAskMessage,
  deniedMessage,
  unsetMessage,
}: PermissionConfigScreenProps) {
  const [permissionResponse, setPermissionResponse] = useState<
    PermissionResponse | undefined
  >(undefined);

  const managedPermission =
    PermissionsManager.getManagedPermission(permissionToken);

  useEffect(() => {
    managedPermission
      .getPermissionResponse()
      .then((res) => {
        setPermissionResponse(res);
      })
      .catch(() => undefined);
  }, []);

  function handleOnPress() {
    if (permissionResponse?.canAskAgain) {
      managedPermission
        .requestPermission()
        .then((res) => {
          setPermissionResponse(res);
          if (res.granted) {
            onGrant?.();
          } else {
            onDeny?.();
          }
        })
        .catch(() => undefined);
    }
  }

  let subHeading;

  if (permissionResponse && !permissionResponse?.canAskAgain) {
    subHeading = cantAskMessage;
  } else if (permissionResponse?.status === PermissionStatus.DENIED) {
    subHeading = deniedMessage;
  } else if (permissionResponse?.status === PermissionStatus.UNDETERMINED) {
    subHeading = unsetMessage;
  }

  const cantAsk = permissionResponse && !permissionResponse.canAskAgain;

  const explicitlyDenied =
    permissionResponse?.status === PermissionStatus.DENIED;

  const disabled = cantAsk || explicitlyDenied;

  return (
    <>
      <View style={{ paddingBottom: Spacings.s5 * 3 }}>
        <Text variant="heading" style={{ textAlign: "center" }}>
          Permission Required ({permissionToken})
        </Text>

        {subHeading && (
          <Text
            variant="heading2"
            color="subdued"
            style={{ textAlign: "center" }}
          >
            {subHeading}
          </Text>
        )}
      </View>

      <Button
        isAction
        label="Grant Permission"
        disabled={disabled}
        onPress={handleOnPress}
      />
    </>
  );
}
